import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import compose from 'lodash.flowright';
import { mapProps } from 'recompose';

import withModal from '../../../../../../../../../../components/global/modal/withModal';
import ShoppingBasketIcon from '../../../../../../../../../../components/icons/ShoppingBasketIcon';
import CheckboxIcon from '../../../../../../../../../../components/icons/CheckboxIcon';
import Button from '../../../../../../../../../../components/global/Button';
import { getPrintPackageItemPrintProductName } from '../helpers';
import EditIcon from '../../../../../../../../../../components/icons/EditIcon';

export const PRINT_PACKAGE_CONFIGURABLE_ITEM_LIST_MODAL =
  'modal/PRINT_PACKAGE_CONFIGURABLE_ITEM_LIST';

const propTypes = {
  cartItem: PropTypes.shape({
    id: PropTypes.string,
  }),
  className: PropTypes.string,
  onClose: PropTypes.func,
  onConfigurableItemUpdate: PropTypes.func.isRequired,
};

const PrintPackageConfigurableItemsListModal = ({
  cartItem,
  className,
  onClose,
  onConfigurableItemUpdate,
}) => {
  const classes = classNames({
    [className]: !!className,
    'print-product-size-success': true,
  });

  const { albumPrintPackage, configurableItems = [] } = cartItem;
  const { print_package: printPackage } = albumPrintPackage;

  return (
    <div className={classes}>
      <div className="print-product-size-success-header">
        <span className="print-product-size-success-header-icon">
          <ShoppingBasketIcon />
          <CheckboxIcon />
        </span>
        <h3 className="text-primary mb-1">{printPackage?.name}</h3>{' '}
        <p className="text-extra-bold text-dark">Select an item to edit:</p>
      </div>

      {configurableItems.map(printPackageItemConfiguration => {
        const { printPackageItem } = printPackageItemConfiguration;

        if (!printPackageItem) {
          return null;
        }

        const printPackageItemName =
          printPackageItem?.type?.name ??
          printPackageItem?.custom_print?.name ??
          getPrintPackageItemPrintProductName(printPackageItem);

        return (
          <Button
            key={printPackageItem.id}
            className="mb-1 text-left d-flex align-items-baseline justify-content-start"
            btnStyle="link"
            onClick={() => {
              onClose();
              onConfigurableItemUpdate(printPackageItemConfiguration);
            }}
            btnBlock
          >
            {printPackageItemName}{' '}
            <EditIcon className="ml-1" color="#0d84fe" size={16} />
          </Button>
        );
      })}

      <div className="print-product-size-success-actions">
        <Button
          btnBlock
          btnSize="lg"
          btnOutline
          onClick={onClose}
          className="btn-checkout-print-product-size-success"
        >
          Dismiss
        </Button>
      </div>
    </div>
  );
};

PrintPackageConfigurableItemsListModal.propTypes = propTypes;

export default withModal(
  compose(
    mapProps(({ onRequestClose, actionProps = {}, ...props }) => ({
      onClose: onRequestClose,
      ...actionProps,
      ...props,
    })),
  )(PrintPackageConfigurableItemsListModal),
  {
    name: PRINT_PACKAGE_CONFIGURABLE_ITEM_LIST_MODAL,
    size: 'xs',
    hideHeader: true,
    dismissible: false,
    shouldCloseOnOverlayClick: false,
    className: 'print-product-size-success-modal-wrap',
  },
);
